// Initialize and add the map
function initMap() {
    if (!document.getElementById("map")) return;
    const mapEl = document.getElementById("map");
    // Däckmarket location.
    const dackmarket = { lat: 67.772134, lng: 24.857120 };
    // The map, centered at Däckmarket
    const map = new google.maps.Map(mapEl, {
      mapId: "1e3cd45321f4a8d7",
      zoom: 15,
      center: dackmarket,
      disableDefaultUI: true,
      zoomControl: true,
    });
    // The marker, positioned at Däckmarket
    const marker = new google.maps.Marker({
      position: dackmarket,
      map: map,
      icon: {
        path: "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z",
        anchor: new google.maps.Point(12, 17),
        fillColor: "#B48F6B",
        fillOpacity: 0.7,
        strokeWeight: 1,
        strokeColor: "#264360",
        scale: 1.5,
        labelOrigin: new google.maps.Point(12, 15),
      },
    });
  }
  
  window.initMap = initMap;
  
  window.addEventListener("load", () => {
    if (!document.getElementById("map")) return;
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyCOfTjBmuLYLddN1sQmB5pOCcExMtZoztk&callback=initMap&v=weekly";
    script.defer = true;
    const head = document.querySelector("head");
    if (!head) return;
    head.append(script);
  });
  